import axios from 'axios'
import { Message, Notification, Loading } from 'element-ui'
import qs from 'qs'
import store from '@/store'
import router from '@/router'
import { getUserToken } from '@/api/auth'
import util from '@/libs/util'

//桩号千米进制转换
const kmKey = ['stake', 'startStake', 'endStake', 'midStakeNum', 'interflowLen', 'nearestStake', 'interchangeStake',
    'tollStationStake', 'positionStake', 'obserStartStake', 'obserEndStake', 'diseaseLocation', 'constructionState', 'safetyStartStake', 'safetyEndStake',
    'usePlace', 'centerStake', 'routeSectionEndStake', 'routeSectionStartStake', 'minStake', 'maxStake'
]
/**
 * 把米转换为千米
 * @param {Any} m
 */
const mToKm = function (m) {
    if (m instanceof Object) {
        for (let key in m) {
            mToKm(m[key])
            for (let i = 0; i < kmKey.length; i++) {
                if (key === kmKey[i]) {
                    m[key] = m[key] / 1000.0
                }
            }
        }
    } else if (m instanceof Array) {
        for (let i = 0; i < m.length; i++) {
            mToKm(m[i])
        }
    } else {
        return
    }
}
/**
 * 把km转换为m
 * @param {Any} m
 */
const kmToM = function (m) {
    if (m instanceof Object) {
        for (let key in m) {
            kmToM(m[key])
            for (let i = 0; i < kmKey.length; i++) {
                if (key === kmKey[i]) {
                    m[key] = (m[key] * 1000.0).toFixed(4)
                }
            }
        }
    } else if (m instanceof Array) {
        for (let i = 0; i < m.length; i++) {
            kmToM(m[i])
        }
    } else {
        return
    }
}
// 创建一个错误
function errorCreate(msg) {
    const error = new Error(msg)
    errorLog(error)
    throw error
}

// 记录和显示错误
function errorLog(error) {
    // 添加到日志
    store.dispatch('d2admin/log/push', {
        message: '数据请求异常',
        type: 'danger',
        meta: {
            error
        }
    })
    // 打印到控制台
    if (process.env.NODE_ENV === 'development') {
        util.log.danger('>>>>>> Error >>>>>>')
        console.log(error)
    }
    // 显示提示
}

// 创建一个 axios 实例
const service = axios.create({
    timeout: 0 // 请求超时时间
})



// 配置是否启用formdata
const formData = false
service.interceptors.request.use( // request 拦截器
    request => {
        if (util.session.get('token')) {
            request.headers['userToken'] = util.session.get('token')
        } else {
            router.push({ path: '/login' })
        }



        if (request.data !== undefined) {
            let dataJson = JSON.stringify(request.data);
            request.data = JSON.parse(dataJson)

        }
        kmToM(request.data)
        if (formData) {
            request.data = qs.stringify(request.data)
            request.headers['Content-Type'] = 'application/x-www-form-urlencoded'
        }
        return request
    },
    error => {
        // do something with request error
        return Promise.reject(error)
    }
)
// response interceptor
service.interceptors.response.use( // response 拦截器
    response => {
        if (response.status !== 200) {
            Notification({
                title: '访问错误',
                message: response,
                type: 'error',
                duration: 2000
            })
            //errorCreate(` ${response.config.url}`)
        }
        const headers = response.headers
        //判断是否是文件流(用于导出)
        if (headers['content-type'] === 'application/octet-stream') {
            return response
        } if (headers['content-type'] === 'application/zip') {
            return response
        } else {
            let data = responseHandle(response)
            if (data) {
                data.data = data.data.list || data.data || data.list
                mToKm(data.data)
            }
            return data
        }

    },
    error => {
        console.log('err' + error) // for debug
        Notification({
            title: '访问错误',
            message: '网络异常,请稍后再试.',
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)


function responseHandle(response) { // 错误代码处理
    const result = response.data
    let msg = ''
    result.detail = result.detail | '无'
    const res = {
        data: result.data,
        pageCount: result.pageCount,
        resCode: result.resCode,
    }
    switch (result.resultCode) {
        case 2000:
            return res
        case 2100:
            res.data = []
            return res
        case 2001:
            msg = result.resultMsg
            Message.error(msg)
            break
        case 2002:
        case 2003:
        case 2004:
        case 2005:
        case 2006:
        case 2007:
        case 2008:
        case 2009:
            msg = result.resultMsg
            util.session.set("logoutMsg", msg)
            router.push({ path: '/login' })
            break
        case 9001:
            msg = '\n 操作异常,请联系管理员'
            // Message.error(msg)
            Message.error(result.data)
            util.log.capsule('错误代码' + result.resultCode, '详情:' + result.data, 'danger') //打印错误
            errorCreate(`${result.resultCode}: ${response.config.url}`)
            break
        case undefined:
            msg = '\n 详情:' + "导出失败"
            Message.error(msg)
            console.log(result);
            break
        default:
            msg = '\n 详情:' + result.resultMsg
            Message.error(msg)
            errorCreate(`${msg}: ${response.config.url}`)
            break
    }
    return null
}

/**
 * get请求
 * @param url
 * @returns {Promise<unknown>}
 */
function get(url, data) {
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: 'get',
            data
        }).then(response => {
            if (response) {
                resolve(response)
            } else {
                reject(response)
            }
        }).catch(error => {

            reject(error)
        })
    })
}

/**
 * download文件导出
 * @param url
 * @returns {Promise<unknown>}
 */
function download(url, data) {
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: 'get',
            data,
            responseType: 'blob'
        }).then(response => {
            if (response) {
                resolve(response)
            } else {
                reject(response)
            }
        }).catch(error => {

            reject(error)
        })
    })
}


/**
 * post请求
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
function postX(url, data) {
    /**
     * 如果不写在请求这里,则可以写在componets/d2-contaniner/index
     */
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: 'post',
            data
        }).then(response => {
            if (response) {
                resolve(response)
            } else {
                reject(response)
            }
        }).catch(error => {
            reject(error)
        })
    })
}


/**
 * post请求
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
function post(url, data) {
    /**
     * 如果不写在请求这里,则可以写在componets/d2-contaniner/index
     */
    let loading = {
        close() { }
    }
    loading = Loading.service({
        lock: true,
        text: '等待服务器响应.....',
        spinner: 'el-icon-loading',
        // target: document.querySelector('.d2-theme-container-main-body'), // 设置加载动画区域
        background: 'rgba(242,242,242, 0.7)'
    })
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: 'post',
            data
        }).then(response => {
            loading.close()
            if (response) {
                resolve(response)
            } else {
                reject(response)
            }
        }).catch(error => {
            loading.close()
            reject(error)
        })
    })
}

/**
 * post请求 会默认提供handle
 * @param handle
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
function postHandle(handle, url, data, loadingMessage) {
    /**
     * 如果不写在请求这里,则可以写在componets/d2-contaniner/index
     */
    let loading = {
        close() { }
    }
    loading = Loading.service({
        lock: true,
        text: loadingMessage || '等待服务器响应.....',
        spinner: 'el-icon-loading',
        // target: document.querySelector('.d2-theme-container-main-body'), // 设置加载动画区域
        background: 'rgba(242,242,242, 0.7)'
    })
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: 'post',
            data
        }).then(response => {
            if (response) {
                if (handle) {
                    Message.success(handle + '成功!')
                }
                resolve(response)
            } else {
                reject(response)
            }
            loading.close()
        }).catch(error => {
            loading.close()

            reject(error)
        })

    })
}

/**
 * 文件导出专用
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
function exportFile(url, data, loadingMessage) {
    let loading = {
        close() { }
    }
    loading = Loading.service({
        lock: true,
        text: loadingMessage || '加载中.....',
        spinner: 'el-icon-loading',
        target: document.querySelector('#app'), // 设置加载动画区域 target: document.querySelector('.d2-theme-container-main-body'),
        background: 'rgba(242,242,242, 0.7)'
    })
    return new Promise((resolve, reject) => {
        service({
            url: url,
            method: 'post',
            data,
            responseType: 'blob',
            headers: { Accept: 'application/vnd.openxmlformats-officedocument' }
            //responseType: 'arraybuffer'
        }).then(response => {

            if (response) {
                resolve(response)
            } else {
                reject(response)
            }
            loading.close()
        }).catch(error => {
            loading.close()
            reject(error)
        })
    })
}
// 创建一个 axios 实例
const primevalAxios = axios.create({
    timeout: 0 // 请求超时时间
})
/**
 * 原生post请求
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
function primevalPost(url, data) {
    return new Promise((resolve, reject) => {
        primevalAxios({
            url: url,
            method: 'post',
            data
        }).then(response => {
            if (response) {
                resolve(response)
            } else {
                reject(response)
            }
        }).catch(error => {

            reject(error)
        })
    })
}
/**
 * 原生get请求
 * @param url
 * @param data
 * @returns {Promise<unknown>}
 */
function primevalGet(url) {
    return new Promise((resolve, reject) => {
        primevalAxios({
            url: url,
            method: 'get'
        }).then(response => {
            if (response) {
                resolve(response)
            } else {
                reject(response)
            }
        }).catch(error => {

            reject(error)
        })
    })
}

// 千寻巡查记录 创建一个 axios 实例
const qxAxios = axios.create({
    timeout: 0, // 请求超时时间

})

function qxGet(headers, url) {
    return new Promise((resolve, reject) => {
        qxAxios({
            url: url,
            method: 'get',
            headers: headers,
        }).then(response => {
            if (response) {
                resolve(response.data)
            } else {
                reject(response)
            }
        }).catch(error => {

            reject(error)
        })
    })
}

export default { get, post, postX, postHandle, download, exportFile, primevalPost, primevalGet, qxGet }
